import type { InputFieldSize } from "../types/inputfield";

const sizeMap = {
	small: { height: "32px", padding: "2px 8px" },
	medium: { height: "40px", padding: "6px 12px" },
	large: { height: "48px", padding: "10px 16px" },
};

export const TextFieldStyles = (isClickable: boolean | undefined, size: InputFieldSize = "medium", error?: boolean) => {
	let height = "40px";
	let padding = "6px 12px";
	if (typeof size === "string" && sizeMap[size]) {
		height = sizeMap[size].height;
		padding = sizeMap[size].padding;
	} else if (typeof size === "object" && size !== null) {
		height = size.height || height;
		padding = size.padding || padding;
	}
	return {
		background: "white",
		cursor: isClickable ? "pointer" : "text",
		"& input": {
			color: "black",
			cursor: isClickable ? "pointer" : "text",
			borderRadius: "10px",
			padding,
			minHeight: "unset",
			height,
			fontFamily: "Poppins, sans-serif",
			paddingLeft: "10px",
			fontSize: "12px",
			fontWeight: "400",
		},
		"& input::placeholder": {
			color: "#98A2B3",
			fontFamily: "Poppins, sans-serif",
			fontSize: "12px",
			fontWeight: "400",
			opacity: 1,
		},

		"& input[type='date']": {
			color: "#000",
			fontSize: "12px",
			fontWeight: "400",
			"&:invalid": {
				color: "#6B7280",
			},
			"&::-webkit-datetime-edit": {
				color: "#6B7280",
			},
			"&:valid::-webkit-datetime-edit": {
				color: "#000",
			},
			"&::-webkit-calendar-picker-indicator": {
				opacity: 0.6,
			},
		},

		"& fieldset": {
			borderColor: error ? "#d32f2f !important" : "#066235 !important",
			borderWidth: 1,
		},
		"&:hover fieldset": {
			borderColor: error ? "#d32f2f !important" : "#066235 !important",
		},
		"&.Mui-focused fieldset": {
			borderColor: error ? "#d32f2f !important" : "#066235 !important",
			borderWidth: "2px !important",
		},
		"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
			borderColor: error ? "#d32f2f !important" : "#066235 !important",
			borderWidth: "2px !important",
		},
		// Error state styling - more specific to override default
		"&.Mui-error fieldset, &.Mui-error .MuiOutlinedInput-notchedOutline": {
			borderColor: "#d32f2f !important",
		},
		"&.Mui-error:hover fieldset, &.Mui-error:hover .MuiOutlinedInput-notchedOutline": {
			borderColor: "#d32f2f !important",
		},
		"&.Mui-error.Mui-focused fieldset, &.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline": {
			borderColor: "#d32f2f !important",
			borderWidth: "2px !important",
		},

		"&.Mui-focused .MuiInputAdornment-root svg": {
			color: "#066235",
		},
		"&.Mui-error .MuiInputAdornment-root svg": {
			color: "#d32f2f",
		},
		"& .MuiInputAdornment-positionStart": {
			marginRight: "0px",
		},
		"& .MuiInputAdornment-positionEnd": {
			marginLeft: "0px",
		},
		// Fix helperText margin to match CustomSelect
		"& .MuiFormHelperText-root": {
			marginLeft: "0px",
			marginTop: "4px",
			fontSize: "11px",
			fontFamily: "Poppins, sans-serif",
			color: error ? "#d32f2f" : "#6B7280", // text-red-500 for errors
		},
	};
};
